import { Step, StepLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import UploadTabSkeleton from '../UploadTabSkeleton';
import { useAppSelector } from '../../../../store/hooks';
import { convertFileFormatToText, getSheetTypes } from '../../../../utils/string';
import AxiomMetadata from '../../../Metadata/AxiomMetadata';
import TabHeader from '../../../TabHeader';
import { UploadFormProvider } from '../UploadFormContext';
import { MoreVert } from '@mui/icons-material';

const AxiomTab: React.FC = () => {
	const fileFormat = useAppSelector((state) => state.upload.currentFileFormat);

	const [selectedFormat, setSelectedFormat] = useState<string>('');

	const allowedFormats = getSheetTypes();

	useEffect(() => {
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setSelectedFormat(fileFormat ? convertFileFormatToText(fileFormat) : '');
	}, [fileFormat]);

	const chooseTab = () => {
		switch (selectedFormat) {
			case 'CSV':
			case 'XLS':
			case 'XLSX':
				return <AxiomMetadata />;
			case '':
				return (
					<Step disabled>
						<StepLabel icon={<MoreVert />}>
							<Typography>More steps will be enabled after a file is uploaded</Typography>
						</StepLabel>
					</Step>
				);
			default:
				return <Typography>Unhandled file format {`(${fileFormat})`}</Typography>;
		}
	};

	return (
		<UploadFormProvider>
			<TabHeader />
			<UploadTabSkeleton allowedFormats={allowedFormats} testTag="axiom-tab-content">
				{chooseTab()}
			</UploadTabSkeleton>
		</UploadFormProvider>
	);
};

export default AxiomTab;
